<template>
  <ifac-maintenance-page
    :loading="isRetrying"
    :on-retry="retry"
  />
</template>

<script>
import { IfacMaintenancePage } from '@ifac/ui';

export default {
  name: 'MaintenancePage',
  components: {
    IfacMaintenancePage,
  },
  data() {
    return {
      isRetrying: false,
    };
  },
  methods: {
    async retry() {
      this.isRetrying = true;
      try {
        await this.$api.get('/status');
        await this.$store.dispatch('maintenance/disable');
        this.$router.replace({ name: 'Home' });
      } catch (error) {
        if (this.$rollbar) {
          this.$rollbar.warning('Maintenance retry failed', error);
        }
      } finally {
        this.isRetrying = false;
      }
    },
  },
};
</script>
